import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pb-2 pt-2" }
const _hoisted_3 = { class: "success d-flex bg-light-success rounded border-success border border-solid" }
const _hoisted_4 = { class: "svg-icon svg-icon-2tx svg-icon-success me-4" }
const _hoisted_5 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "fs-6 text-gray-600" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "My Notes:", -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "All Notes:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTReviewNoteModal = _resolveComponent("KTReviewNoteModal")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_KTReviewNoteModal, { type: _ctx.propType }, null, 8, ["type"]),
    ((_ctx.currentIrbReviewNote != null && _ctx.currentIrbReviewNote.note != '') || (_ctx.currentIrbReviewNoteType != null && _ctx.currentIrbReviewNoteType.data != null && _ctx.currentIrbReviewNoteType.data.length > 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen043.svg" })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.currentIrbReviewNote != null && _ctx.currentIrbReviewNote.note != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _hoisted_9,
                          _createTextVNode(" " + _toDisplayString(_ctx.currentIrbReviewNote.note), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.currentIrbReviewNote != null && _ctx.currentIrbReviewNote.note != '')
                      ? (_openBlock(), _createElementBlock("hr", _hoisted_10))
                      : _createCommentVNode("", true),
                    (_ctx.currentIrbReviewNoteType != null && _ctx.currentIrbReviewNoteType.data != null && _ctx.currentIrbReviewNoteType.data.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentIrbReviewNoteType.data, (row) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: row.id
                            }, _toDisplayString("-" + row.reviewerName + ": "+ row.note), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}